import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import {
  Actionsheet,
  Heading,
  ScrollView,
  Pressable,
  HStack,
  Box,
} from "native-base";
import { COLORS } from "../../utils/colors";
import Svg from "react-native-svg";
import { closeIconSvg } from "../../utils/svg";

const CloseButton = ({ onPress }) => {
  const customTextStyle = {
    transform: [{ translateX: 0 }, { translateY: -4 }],
  };
  return (
    <Pressable onPress={onPress} style={customTextStyle}>
      <Svg width="36" height="36" viewBox="0 0 36 36">
        {closeIconSvg}
      </Svg>
    </Pressable>
  );
};

const MobileModelSheet = forwardRef(
  (
    {
      isOpen,
      onClose,
      header = "",
      body = "",
      footer,
      maxH = undefined,
    },
    ref
  ) => {
    const scrollViewRef = useRef(null);

    useEffect(() => {
      if (isOpen) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "";
      }
      return () => {
        document.documentElement.style.overflow = "";
      };
    }, [isOpen]);

    const scrollToTop = () => {
      if (scrollViewRef.current) {
        scrollViewRef.current.scrollTo({ y: 0, animated: true });
      }
    };

    useImperativeHandle(ref, () => ({
      scrollToTop,
    }));

    return (
      <>
        <Actionsheet zIndex={"1"} isOpen={isOpen} onClose={onClose}>
          <Actionsheet.Content
            background={COLORS.WHITE_COLOR}
            borderTopLeftRadius={0}
            borderTopRightRadius={0}
            py={2}
            maxH={maxH}
          >
            <HStack
              bg={COLORS.WHITE_COLOR}
              borderBottomWidth={0}
              width={"95%"}
              mb={header && 5}
              px={1}
              justifyContent={"space-between"}
            >
              {header && (
                <Box width={"90%"}>
                  <Heading size="md" fontSize={"24px"}>
                    {header}
                  </Heading>
                </Box>
              )}
              <CloseButton onPress={onClose} />
            </HStack>
            {body && (
              <ScrollView width={"93%"} px={1} py={1} ref={scrollViewRef}>
                {body}
              </ScrollView>
            )}
            {footer && (
              <HStack width={"100%"} py={3} px={2}>
                {footer}
              </HStack>
            )}
          </Actionsheet.Content>
        </Actionsheet>
      </>
    );
  }
);
export default MobileModelSheet;
